import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const HomeAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  routes: [
    {
      path: routesUrl.home,
      exact: true,
      component: React.lazy(() => import('./pages/HomePage')),
    },
  ],
};

export default HomeAppConfig;
